import React from 'react'

const ServiceDetailsVideo = () => {
  return (
    <div>ServiceDetailsVideo</div>
  )
}

export default ServiceDetailsVideo